import {Record, List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import {SortDirection, flipDirection} from 'web-app/util/sorting';

import {SORT_KEYS} from './constants';
import * as Actions from './actions';
import {assignRoleInvitation} from '../invite-parents/actions';

export interface ManageChildrenStateProps {
    readonly loading: boolean;
    readonly childIds: List<string>;
    readonly showAddChildModal: boolean;
    sortKey: SORT_KEYS;
    sortDirection: SortDirection;
    readonly roleInvitationIds: List<string>;
}

const defaultSortDirection = SortDirection.ASC;

export class ManageChildrenState extends Record<ManageChildrenStateProps>({
    loading: false,
    childIds: List(),
    showAddChildModal: false,
    sortDirection: defaultSortDirection,
    sortKey: SORT_KEYS.CHILD_NAME,
    roleInvitationIds: List(),
}) {}

export default makeReducer<ManageChildrenState>(
    [
        match(
            Actions.fetchChildren,
            () =>
                new ManageChildrenState({
                    loading: true,
                }),
        ),
        match(Actions.fetchChildrenSuccess, (state, {payload}) =>
            state.merge({
                loading: false,
                childIds: List(payload.children.map(child => child.childId)),
            }),
        ),
        match(Actions.fetchChildrenFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
        match(Actions.toggleSorting, (state, {payload}) =>
            state.merge({
                sortKey: payload.sortKey,
                sortDirection:
                    payload.sortKey !== state.sortKey ? defaultSortDirection : flipDirection(state.sortDirection),
            }),
        ),
        match(Actions.setShowModal, (state, {payload}) =>
            state.merge({
                showAddChildModal: payload.show,
            }),
        ),
        match(Actions.createNewChildSuccess, (state, {payload}) =>
            state.merge({childIds: state.childIds.push(payload.childId)}),
        ),
        match(Actions.setRoleInvitationIds, (state, {payload}) =>
            state.merge({
                roleInvitationIds: List(payload.roleInvitationIds),
            }),
        ),
        match(assignRoleInvitation, (state, {payload}) =>
            state.merge({
                roleInvitationIds: state.roleInvitationIds.push(payload.relationId),
            }),
        ),
    ],
    new ManageChildrenState(),
);
